<div class="row px-0">
     <div class="col-9 pl-2 pr-0 header-status ag-header-cell-text">  {{status}}</div>
         
        <div class=" col-1 px-1">
          <span class="tooltip sg-infoicon icon-position">
              <p class="material-icons-outlined float-right" [tooltip]="template" contentType="template"
                      [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline</p>
                  <div class="tooltiptext" id="cwsTooltipContent">
                      <ng-template #template class="w-100">
                          <div class="row mx-0 w-100">
                              <div class="col-12 w-100 px-0">
                                  <span style="text-align:left;" *ngIf="this.status == 'Is Expired?'"> 
                                    An item is Expired when today's date exceeds the start Date + Days<br>
                                    to show. Expired items are hidden in Home page
                                  </span>

                                  <!-- <span style="text-align:left;" *ngIf="this.status == 'Is Deleted'">
                                    An item is Deleted only when it was manually marked<br>
                                    as deleted in the Edit screen
                                  </span>  -->

                                  <span style="text-align:left;" *ngIf="this.status == 'Document Name'">
                                    You can search by Document Name or extension. Example: '.xlsx'
                                  </span>
                                 
                              </div>
                          </div>
                      </ng-template>
                  </div>
            </span>
        </div>
      <div class="col-1 px-0 header-sort-icon">
      <span class="ag-header-icon ag-header-label-icon1 ag-sort-none-icon" id="initialId">
        <span class="ag-icon ag-icon-none initial" unselectable="on" role="presentation" (click)="initialSort()"></span>
      </span>
      <span id="ascId" style="display:none;" (click)="onSortRequested('asc', $event)" [ngClass]="ascSort" class="customSortDownLabel">
        <i class="ag-icon ag-icon-asc pt4"></i>
      </span> 
      <span id="descId" style="display:none;" (click)="onSortRequested('desc', $event)" [ngClass]="descSort" class="customSortUpLabel">
        <i class="ag-icon ag-icon-desc pt4"></i>
      </span> 
    </div>
      </div>
  <div>
</div>